module.exports = __webpack_public_path__ + "img/icon_password-01.6aec75f7.svg";